module.exports = __webpack_public_path__ + "img/HomePLCConfigLogo.d66b04ee.png";